import TemplateView from '../../../../../../js/TemplateView'
import FeedUserSelection from './FeedUserSelection'
import FeedLeaveTypesSelection from './FeedLeaveTypesSelection'

export default class FeedDetailsCell extends TemplateView {
    constructor({
        leaveTypes,
        userSelection,
    }) {
        super()

        this.params = {
            leaveTypes,
            userSelection,
        }
    }

    templateHtml() {
        return '<div class="feedDetailsCell"/>'
    }

    afterRender() {
        new FeedLeaveTypesSelection({
            leaveTypes: this.params.leaveTypes,
        }).init(this.getEl())

        new FeedUserSelection({
            userSelection: this.params.userSelection,
            shared: false,
        }).init(this.getEl())
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/FeedDetailsCell.js